import ReportingService from "@pency/api/reporting";

export default new ReportingService(process.env.SENTRY_DSN);
